import { TextArea, Typography } from "components/atoms";

interface IProps {
  fieldName: any;
  answer: any;
  maxLength: number;
  onAnswerChange: (id: string, value: any) => void;
}

export const TextAreaInput = ({
  fieldName,
  answer,
  maxLength,
  onAnswerChange,
}: IProps) => {
  return (
    <div className="text-area-with-limit-wrapper">
      <TextArea
        rows={3}
        value={answer || ""}
        setValue={(value) => onAnswerChange(fieldName, value)}
        maxLength={maxLength}
      />
      <Typography
        label={`Characters left: 
            ${maxLength - ((answer && answer.length) || 0)}`}
        variant="h7Book"
        styles="character-limit-text-style"
      />
    </div>
  );
};
